import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface VerifyFAState {
  showVerifyFA: boolean;
  showSuggestTfa: boolean;
}

const initialState: VerifyFAState = {
  showVerifyFA: false,
  showSuggestTfa: false,
};

const verifyFASlice = createSlice({
  name: 'verifyFA',
  initialState,
  reducers: {
    setShowVerifyFA(state, action: PayloadAction<boolean>) {
      state.showVerifyFA = action.payload;
    },
    setSuggestFA(state, action: PayloadAction<boolean>) {
      state.showSuggestTfa = action.payload;
    },
  },
});

export const { setShowVerifyFA, setSuggestFA } = verifyFASlice.actions;

export default verifyFASlice.reducer;
